/*
 * Call to action JS
 *
 * @version : 1.0.0
 * @author : Arif Amir
 */

ckdc.ready(function ($) {

    if (typeof ckdc == 'undefined') {
        return;
    }

    ckdc.setup.addSetupContent('call-to-actions', setupContent);

    function setupContent(content) {

        var feedBackCircle = content.find('.feedback-cta-circle');
        feedBackCircle.on("click touchstart", function (e) {
            e.preventDefault();
            var $this = $(this),
                feedBackReceived = $this.text(),
                postTitle = $this.data('title');

            if (feedBackReceived && postTitle) {
                ckdc.events.ga4('feedback-widget', 'click', {title: postTitle, feedback: feedBackReceived});
            }

            $this.parent().css("display", "none").next().removeClass('hide');

            return false;
        });
    }
});
